// extracted by mini-css-extract-plugin
export var bottomText = "styles-module__bottomText___PLdad";
export var container = "styles-module__container___alGB0";
export var doubleDigitPadding = "styles-module__doubleDigitPadding___pDmXn";
export var extreme = "styles-module__extreme___dUTi2";
export var high = "styles-module__high___aHtuW";
export var iconContainer = "styles-module__iconContainer___evy5e";
export var low = "styles-module__low___kucMb";
export var moderate = "styles-module__moderate___yDtmE";
export var overlayContainer = "styles-module__overlayContainer___fyog2";
export var text = "styles-module__text___EegLD";
export var veryHigh = "styles-module__veryHigh___lrNsJ";
export var weatherImage = "styles-module__weatherImage___C3s5y";